import { render, staticRenderFns } from "./ProductsLocationsModal.vue?vue&type=template&id=dcc4ce34&"
import script from "./ProductsLocationsModal.vue?vue&type=script&lang=js&"
export * from "./ProductsLocationsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports